export const selectionColumns = [
    {
      field: "skuCode",
      headerName: "SKU Code",
      sortable: false,
      align: "left",
      flex: 1.8,
      minWidth: 130,
    },
    {
      field: "customerCode",
      headerName: "Customer Code",
      sortable: false,
      align: "left",
      flex: 1.3,
      minWidth: 130,
    },
    {
      field: "vendorCode",
      headerName: "Vendor Code",
      sortable: false,
      align: "left",
      flex: 1.3,
      minWidth: 130,
    },
    {
      field: "category",
      headerName: "Category",
      sortable: false,
      align: "left",
      flex: 1.3,
      minWidth: 160,
    },
    {
      field: "group",
      headerName: "SKU Group",
      sortable: false,
      align: "left",
      flex: 1.3,
      minWidth: 130,
    },
    {
      field: "subgroup",
      headerName: "SKU Sub Group",
      sortable: false,
      align: "left",
      flex: 1.3,
      minWidth: 130,
    },
  ];